export var Position;
(function (Position) {
    Position["BELOW"] = "below";
    Position["ABOVE"] = "above";
    Position["DYNAMIC"] = "dynamic";
})(Position || (Position = {}));
